import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { QuestionnaireService } from '../../../../services/questionnaire/questionnaire.service';
import {PermissionsService} from "../../../../services/permissions/permissions.service";


@Component({
  selector: 'app-edit-questionnaire-named-modal',
  templateUrl: './edit-questionnaire-title-modal.component.pug',
  styleUrls: ['./edit-questionnaire-title-modal.component.scss'],
  standalone: false
})
export class EditQuestionnaireTitleModalComponent implements OnInit {
  questionnaireId: string = "";
  questionnaireTitle = "";
  questionnaireTitleChange: EventEmitter<any> = new EventEmitter<string>();
  cancelClick: EventEmitter<any> = new EventEmitter();

  initialTitle: string = '';
  invalidTitle = false;
  wrongPattern = false;
  // refer to OMNI-1455 in case of clarification needed about the regex
  titlePattern = new RegExp(/[^a-zA-Z0-9 _\-():',.\/&]+/);

  constructor(
    public bsModalRef: BsModalRef,
    private permissions: PermissionsService,
    private questionnaireService: QuestionnaireService ) { }

  ngOnInit(): void {
    this.initialTitle = this.questionnaireTitle;
  }

  titleChange(title){
    this.invalidTitle=false;
    let patternMatch = this.titlePattern.test(title);
    this.wrongPattern = patternMatch;
  }

  isSavedDisabled(): boolean {
    return !this.questionnaireTitle || this.invalidTitle || this.wrongPattern || (this.initialTitle === this.questionnaireTitle);
  }

  cancel(){
    this.questionnaireTitle = '';
    this.cancelClick.emit({});
    this.bsModalRef.hide();
  }

  next(): void {
    this.questionnaireService.validateQuestionnaireTitle(this.questionnaireTitle, this.questionnaireId).subscribe(response => {
        if (response?.exists) {
          this.invalidTitle = true;
        } else {
          this.questionnaireTitleChange.emit({data: this.questionnaireTitle});
          this.questionnaireTitle = '';
          this.bsModalRef.hide();
        }
      },
      error => {
      });
  }

}
